import { styled, Box, StyleSystemProps } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

export const StyledWrapper = styled(Box)``;
export const StyledTotalColors = styled(Box)``;
export const StyledSwatch = styled(Box)``;
export const StyledSwatchFrame = styled(Box)``;

const rootStyles: StyleSystemProps = {
  display: 'flex',
  gridGap: 3,
  flexWrap: 'wrap',
  maxWidth: '100%',
  paddingTop: '2px'
};

const frameStyles: StyleSystemProps = {
  paddingX: 1,
  paddingBottom: 3,
  position: 'relative'
};

const overflowCountStyles: StyleSystemProps = {
  backgroundColor: 'transparent',
  color: '#404040',
  fontSize: 100,
  // size: 6,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const overflowCountDarkBgStyles: StyleSystemProps = {
  ...overflowCountStyles,
  color: 'white'
};

const swatchStyles: StyleSystemProps = {
  // size: 6,
  borderRadius: '100%',
  boxShadow: 'rgb(0 0 0 / 25%) 0px 0px 2px 0px inset',
  position: 'relative',
  _hover: {
    opacity: 0.8,
    _after: {
      opacity: 1,
      borderColor: 'mono10'
    },
    _readOnly: {
      _before: {
        borderTopColor: 'mono10'
      }
    }
  },

  transition: animationTransition('opacity'),
  _after: {
    position: 'absolute',
    content: "' '",
    opacity: 0,
    size: 'calc(100% + 6px)',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'transparent',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: 'mono14',
    borderRadius: '100%',
    transition: animationTransition('opacity')
  },
  _readOnly: {
    _before: {
      content: "' '",
      position: 'absolute',
      transform: 'translate(-20%,35%) rotate(-45deg)',
      width: 'calc(100% + 6px)',
      height: 'calc(100% - 1px)',
      borderTopWidth: '2px',
      borderTopStyle: 'solid',
      borderTopColor: 'mono2',
      mixBlendMode: 'difference'
    }
  }
};

export const styles = {
  root: rootStyles,
  swatchFrame: frameStyles,
  swatch: swatchStyles,
  overflowCount: overflowCountStyles,
  overflowCountDarkBg: overflowCountDarkBgStyles
};
